export class URLUtils {
    static getUrlParams(): ?URLSearchParams {
        const hash = window.location.hash;
        const queryString = hash.split("?")[1]; // Récupère "name=a&type=b"

        if (queryString) {
            return new URLSearchParams(queryString);
        }
    }
}
